module.exports = __webpack_public_path__ + "img/13_31.731a971c.png";